import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setAppTitle } from '../../../store/commonSlice'
import { ApiServiceContext } from '../../../utils/shared.module'
import { end_points } from '../../../services/core.index'
import { Link } from 'react-router-dom'

import { routes } from '../../../utils/routes'
import { useParams } from 'react-router-dom'

import {
  chart,
  truck1,
  truck2,
  truck3,
  truck4,
  truck5,
  truck6,
  truck7,
} from '../../../utils/images/imagepath'

import {
  avatar1,
  avatar11,
  avatar13,
  avatar17,
  avatar2,
  avatar29,
  avatar30,
} from '../../../utils/images/imagepath'
import Search from 'antd/es/transfer/search'

function TruckListView() {
  const { userId, truckId } = useParams<{ truckId: string; userId: string }>()
  const { getData } = useContext(ApiServiceContext)
  const [listData, setListData] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(false)

  const getTruckTranscationList = async (
    userId: number,
    truckId: number,
    search?: any,
  ) => {
    let nameSearch = search
    if (nameSearch == undefined) {
      nameSearch = ''
    }
    let urls = end_points.getTruckInspection.url
    urls += `?Userid=${userId}&TruckId=${truckId}`

    const response = await getData(urls)
    if (response?.status == 200) {
      console.log(response?.data)
      setListData(response?.data)
      // setTotal(response?.data?.total_records)

      setLoading(false)
    }
  }

  useEffect(() => {
    getTruckTranscationList(userId, truckId)
  }, [userId, truckId])

  const dataList = listData.map((item: any) => {
    return {
      // status: item?.truck_Status ? "active" : "inactive",
      transactionId: item?.transactionId,
      truck_name: item?.model,
      trans_CreatedOn: item?.trans_CreatedOn,
      username: item?.username,
      license_Plate: item?.license_Plate,
      companyName: item?.companyName,
    }
  })

  const truckDetails = (data: any, index: any) => {
    return (
      <>
        <h2 className='table-avatar'>
          <a href='javascript:void(0);' className='avatar avatar-sm me-2'>
            <img
              className='avatar-img rounded-circle'
              src={truck2}
              alt='Profiles'
            />
          </a>
          <a href='javascript:void(0);'>{data.license_Plate}</a>
        </h2>
      </>
    )
  }

  const driverDetails = (data: any, index: any) => {
    return (
      <>
        <h2 className='table-avatar'>
          <a href='javascript:void(0);' className='avatar avatar-sm me-2'>
            <img
              className='avatar-img rounded-circle'
              src={avatar1}
              alt='Profiles'
            />
          </a>
          <a href='javascript:void(0);'>
            {data.username} <span>{data.companyName}</span>
          </a>
        </h2>
        <h2 className='table-avatar'>
          <a href='javascript:void(0);' className='avatar avatar-sm me-2'>
            <img
              className='avatar-img rounded-circle'
              src={avatar1}
              alt='Profiles'
            />
          </a>
          <a href='javascript:void(0);'>
            {data.username} <span>{data.companyName}</span>
          </a>
        </h2>
      </>
    )
  }

  const inspectorDetails = (data: any, index: any) => {
    return <>Cameron Jacob</>
  }

  const inspectionDate = (data: any, index: any) => {
    return <>{data.trans_CreatedOn}</>
  }

  const checkList = (data: any, index: any) => {
    return (
      <>
        <div className='data-check-list'>
          <ul className='nav'>
            <li>
              <span className='check-list-active'></span>
            </li>
            <li>
              <span className='check-list-active'></span>
            </li>
            <li>
              <span className='check-list-active'></span>
            </li>
            <li>
              <span className='check-list-active'></span>
            </li>
            <li>
              <span className='check-list-active'></span>
            </li>
            <li>
              <span className='check-list-active'></span>
            </li>
          </ul>
          <p>
            28/<span>30</span>
            <Link className='view-checklist' to={routes.truckCheckList.path}>
              View Checklist
            </Link>
          </p>
        </div>
      </>
    )
  }

  const status = (data: any, index: any) => {
    return (
      <>
        <span className='badge bg-light-success'>Active</span>
      </>
    )
  }

  const action = (data: any, index: any) => {
    return (
      <>
        <div className='dropdown'>
          <a
            href='javascript:void(0);'
            className='dropdown-toggle'
            data-bs-toggle='dropdown'
          >
            <i className='feather-more-vertical'></i>
          </a>
          <div className='dropdown-menu dropdown-menu-end'>
            {/* <Link
                to={routes.checkListDetailView.path}
                className='dropdown-item'
              >
                <i className='feather-eye'></i> View
              </Link> */}
            <Link
              to={`/checklist/check-list-detail/1`}
              className='dropdown-item'
            >
              <i className='feather-eye'></i> View
            </Link>
            <a href='javascript:void(0);' className='dropdown-item'>
              <i className='feather-edit'></i> Edit
            </a>
            <a href='javascript:void(0);' className='dropdown-item'>
              <i className='feather-trash-2'></i> Delete
            </a>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div className=''>
        <div className='page-header'>
          <div className='row align-items-center'>
            <div className='col-sm-6'>
              <h3 className='page-title'>Manage Check List</h3>
            </div>
            <div className='col-sm-6'>
              <ul className='breadcrumb'>
                <li className='breadcrumb-item active'>
                  <a href='index.html'>Home</a>
                </li>
                <li className='breadcrumb-item'>Manage Check List</li>
              </ul>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12'>
            <div className='card table-card'>
              <div className='card-body'>
                <div className='row align-items-center'>
                  <div className='col-md-6'>
                    <div id='tablelength'></div>
                  </div>
                  <div className='col-md-6'>
                    <ul className='nav nav-table-filter'>
                      <li>Search:</li>
                      <li>
                        <div id='tablefilter'></div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='table-responsive'>
                  <table className='table datatable mb-0'>
                    <DataTable
                      // paginatorTemplate='CurrentPageReport  PrevPageLink PageLinks NextPageLink  '
                      // currentPageReportTemplate='{first} to {last} of {totalRecords} items'
                      className=''
                      value={dataList}
                      paginator
                      rows={5}
                      tableStyle={{ minWidth: '50rem' }}
                    >
                      <Column
                        field='truck_details'
                        header='Truck Details'
                        body={truckDetails}
                        sortable
                      ></Column>
                      <Column
                        field='Licene Number'
                        header='Driver Details'
                        body={driverDetails}
                        sortable
                      ></Column>
                      <Column
                        field='Contact'
                        header='Inspector Details'
                        body={inspectionDate}
                        sortable
                      ></Column>
                      <Column
                        field='checklist'
                        header='Check List'
                        body={checkList}
                        sortable
                      ></Column>

                      <Column
                        field='status'
                        header='Status'
                        body={status}
                        sortable
                      ></Column>
                      <Column body={action}></Column>
                    </DataTable>
                  </table>
                </div>
                <div className='tab-footer'>
                  <div className='row align-items-center'>
                    <div className='col-md-6'>
                      <div id='tableinfo'></div>
                    </div>
                    <div className='col-md-6'>
                      <div id='tablepage'></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default TruckListView
